/* ==========================================================
   MISS SWIG - product card media behaviour
   ----------------------------------------------------------
   Delegated and idempotent. Re-scans on shopify:section:load so
   cards injected later (recently viewed, recommendations) work
   without any extra wiring.
   ========================================================== */
(function () {
  var DRAG_TOLERANCE = 8; /* px of travel before a tap counts as a swipe */

  function activeIndex(track) {
    var slides = track.querySelectorAll('.mscm-slide');
    if (!slides.length) return 0;
    var mid = track.scrollLeft + track.clientWidth / 2;
    var best = 0;
    var bestDist = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var c = slides[i].offsetLeft + slides[i].offsetWidth / 2;
      var d = Math.abs(c - mid);
      if (d < bestDist) { bestDist = d; best = i; }
    }
    return best;
  }

  /* Play only the video on the visible slide, and only while the card
     itself is on screen. Source is attached on first need, so nothing
     downloads until someone actually looks at it. */
  function syncVideo(root, idx) {
    var slides = root.querySelectorAll('.mscm-slide');
    for (var i = 0; i < slides.length; i++) {
      var v = slides[i].querySelector('video');
      if (!v) continue;
      if (i === idx && root.getAttribute('data-inview') === '1') {
        if (!v.getAttribute('src') && v.getAttribute('data-mscm-src')) {
          v.setAttribute('src', v.getAttribute('data-mscm-src'));
        }
        v.muted = true;
        var p = v.play();
        if (p && p.catch) { p.catch(function () {}); }
        v.style.opacity = '1';
      } else {
        if (!v.paused) { v.pause(); }
        v.style.opacity = '0';
      }
    }
  }

  function syncDots(root) {
    var track = root.querySelector('[data-mscm-track]');
    if (!track) return;
    var idx = activeIndex(track);
    var dots = root.querySelectorAll('.mscm-dot');
    for (var i = 0; i < dots.length; i++) {
      if (i === idx) { dots[i].classList.add('is-active'); }
      else { dots[i].classList.remove('is-active'); }
    }
    syncVideo(root, idx);
  }

  function goTo(track, idx) {
    var slides = track.querySelectorAll('.mscm-slide');
    if (!slides[idx]) return;
    track.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
  }

  function bind(root) {
    if (!root || root.getAttribute('data-mscm-bound')) return;
    root.setAttribute('data-mscm-bound', '1');

    var track = root.querySelector('[data-mscm-track]');
    if (!track) return;

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        syncDots(root);
        ticking = false;
      });
    }, { passive: true });

    /* A swipe must not fire the link. Measure travel, cancel the click. */
    var startX = 0;
    var startY = 0;
    var moved = false;

    track.addEventListener('pointerdown', function (e) {
      startX = e.clientX;
      startY = e.clientY;
      moved = false;
    }, { passive: true });

    track.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientX - startX) > DRAG_TOLERANCE ||
          Math.abs(e.clientY - startY) > DRAG_TOLERANCE) {
        moved = true;
      }
    }, { passive: true });

    track.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    /* Desktop: hover advances to the second media, as it did before. */
    if (window.matchMedia && window.matchMedia('(hover:hover)').matches) {
      root.addEventListener('mouseenter', function () {
        if (track.querySelectorAll('.mscm-slide').length > 1) { goTo(track, 1); }
      });
      root.addEventListener('mouseleave', function () {
        goTo(track, 0);
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          root.setAttribute('data-inview', entries[i].isIntersecting ? '1' : '0');
        }
        syncVideo(root, activeIndex(track));
      }, { threshold: 0.35 });
      io.observe(root);
    } else {
      root.setAttribute('data-inview', '1');
    }

    syncDots(root);
  }

  function scan(scope) {
    var nodes = (scope || document).querySelectorAll('[data-mscm]');
    for (var i = 0; i < nodes.length; i++) { bind(nodes[i]); }
  }

  if (document.readyState !== 'loading') { scan(document); }
  document.addEventListener('DOMContentLoaded', function () { scan(document); });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
